import {Header} from "./Header";

export function AnalyseLayout({children}){
    return(
        <>
            <Header />
            <main className="analyse-wrapper">
                {children}
            </main>
        </>
    )
}